// The backend serializes naive UTC datetimes via isoformat(), with no "Z".
// new Date() reads a zone-less ISO string as *local* time, so for a visitor
// in India every server timestamp showed 5h30m early. Treat zone-less strings
// as UTC; strings that already carry Z or an offset are left alone.
export function parseTimestamp(value) {
  if (typeof value === "string" && /T\d{2}:\d{2}/.test(value) && !/(Z|[+-]\d{2}:?\d{2})$/i.test(value)) {
    return new Date(`${value}Z`);
  }
  return new Date(value);
}
